import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DeliveryAndShipmentTimes } from './delivery-time-graph.service';
import pluralize from '@prlw/libs/pluralize/pluralize';
import { AbstractGraphTooltipComponent } from '../graph-common/abstract-graph-tooltip.component';

@Component({
  selector: 'prlw-delivery-time-graph-tooltip',
  templateUrl: './delivery-time-graph-tooltip.component.html',
  styleUrls: [
    '../graph-common/tooltips.scss',
    './delivery-time-graph-tooltip.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryTimeGraphTooltipComponent extends AbstractGraphTooltipComponent<DeliveryAndShipmentTimes> {
  public daysPlural(days: number | null): string {
    return days ? pluralize(days, ['день', 'дня', 'дней']) : '';
  }
}
